import React, { useState, useEffect } from "react";
import { forEach, get, size } from "lodash";
import { useDispatch, useSelector } from "react-redux";
import { Controller } from "react-hook-form";
import { makeStyles } from "@material-ui/core/styles";
import {
  Box,
  Button,
  Typography
} from "@material-ui/core";
import { countryList } from "../../v2_actions/country";
import { TextField } from "./TextField";
import { getLoggedInUserId } from "../../v2_actions/auth";
import { getUserStoredCountry } from "../../v2_actions/auth_country";

import { CurrencyValue } from "../CurrencyValue";

import { GalleryPriceDiscountFormFields } from '../GalleryPriceDiscountFormFields'
import { GalleryHighLowResPriceFormFields } from '../GalleryHighLowResPriceFormFields'

const useStyles = makeStyles({
  setFolderWrapper: {
    padding: 15,
    display: "flex",
    flexDirection: "column",
    zIndex: 99,
  },
  setPriceWrapper: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    width: "100%",
    borderRadius: 20,
    position: "relative",
    background:
    "linear-gradient(to right, rgb(170, 255, 251) 1%, rgb(1, 132, 255) 100%)",
  },
  small_typography: {
    width: "23%",
    color: "#7A7A7A",
    display: "flex",
    fontSize: 12,
    fontWeight: "600",
    cursor: "pointer",
    paddingLeft: "5px",
  },
  map_typography: {
    width: "90%",
    color: "#7A7A7A",
    display: "flex",
    padding: 0,
    fontSize: 12,
    fontWeight: "600",
    cursor: "pointer",
  },
  normalWhiteBtn: {
    width: 200,
    height: 50,
    backgroundColor: "white !important",
    color: "blue",
    borderRadius: 20,
    border: "1px solid",
    textTransform: "capitalize",
    borderColor: "black",
  },
  smallTextField: {
    margin: '0px 10px 0px 0px',
    background: '#ebebeb',
    height: 23,
    width: 45,
    // textDecoration: "underline",
    //
    "& input": {
      marginTop: 5,
      textAlign: 'center',
      textDecoration: 'none',
      padding: 0,
    },
  },
  pricing_typography: {
    color: "#7A7A7A",
    display: "flex",
    paddingLeft: "10px",
    fontSize: 12,
    fontWeight: "600",
    cursor: "pointer",
  },
  pricing_typography1: {
    color: "#7A7A7A",
    display: "flex",
    paddingLeft: "0px",
    fontSize: 12,
    width: 170,
    fontWeight: "600",
    cursor: "pointer",
  },

  unset_button: {
    backgroundColor: "#cfcfcf !important",
    color: "#0c59cf",
    boxShadow: "2px 4px 10px rgba(0, 0, 0, 0.69)",
    borderRadius: 5,
    textTransform: "capitalize",
    width: "95%",
    textAlign: "left",
    marginTop: 5,
  },
  set_button: {
    backgroundColor: "green !important",
    color: "white",
    boxShadow: "2px 4px 10px rgba(0, 0, 0, 0.69)",
    borderRadius: 5,
    textTransform: "capitalize",
    width: "95%",
    textAlign: "left",
    marginTop: 5,
  },
  white_icon: {
    color: "white",
    width: 25,
    height: 25,
  },
  icon: {
    color: "black",
    width: 25,
    height: 25,
  },
  flexBtn: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between ",
    width: "300px",
    paddingLeft: "5px",
    paddingRight: "5px",
    paddingTop: "15px",
    paddingBottom: "15px",
  },
  flex1: {
    position: "absolute",
    left: "2%",
  },
  flex2: {
    position: "absolute",
    left: "15%",
    width: "75%",
    textTransform: "none",
    marginRight: "0px",
  },
  galleryPriceDiscountCurrencyValueWrapper: {
    marginLeft: 5,
    display: 'inline-flex',
    '& span': {
      width: 20
    }
  }
});

export const GalleryPriceSelector = ({
  formProps,
  gallery,
  gallery_id,
  gallery_type,
  field_name_prefix,
  isEditorForPhotoArt
}) => {

  const classes = useStyles();
  const dispatch = useDispatch();
  const photographer = getLoggedInUserId();
  const { control, getValues, watch } = formProps;
  const country = useSelector(() =>
    get(gallery, "country")
      ? countryList.getCountryForId(gallery.country)
      : getUserStoredCountry(),
  );
  let item_name = gallery_type === "photo_art" ? "Photograph" : "Gallery";
  const [showForm, setShowForm] = useState(false);
  const [optionalLowResPriceChecked, setOptionalLowResPriceChecked] = useState(formProps.getValues('gallery_price.low_res_price') !== null)
  
  
  const required_fields = [
    `${field_name_prefix}.base_price`,
    `${field_name_prefix}.low_res_price`,
    `${field_name_prefix}.discount1_percentage`,
    `${field_name_prefix}.discount2_percentage`,
    `${field_name_prefix}.discount3_percentage`,
    `${field_name_prefix}.discount4_percentage`,
  ];
  const values = watch(required_fields);
  const [discountedValues, setDiscountedValues] = useState({});
  const [isButtonTouched, setButtonTouched] = useState(false);

  useEffect(() => {
    if (size(values) === size(required_fields)) {
      const base_price = values[0];
      const calculatedDiscountedValues = {};
      forEach(required_fields, (required_field, index) => {
        const discount_percent = values[index];
        calculatedDiscountedValues[required_field] = (
          base_price *
            ((100 - discount_percent) / 100)
        ).toFixed(2);
      });
      setDiscountedValues(calculatedDiscountedValues);
    }
  }, values);

  const handleOptionalLowResPriceChange = (event) => {
    setOptionalLowResPriceChecked(event.target.checked)
    
    if (!event.target.checked) {
      formProps.setValue('gallery_price.low_res_price', null)
    }
  }


  const renderPriceField = (fieldProps, disabled) => {
    return (
      <>
        &nbsp;&nbsp;
        <TextField
          disabled={disabled}
          type="text"
          variant="standard"
          fieldProps={fieldProps}
          className={classes.smallTextField}
          InputProps={{ disableUnderline: true }}
        />
      </>
    );
  };

  const renderDiscountPriceField = (fieldProps) => {
    return (
      <>
        <TextField
          fieldProps={fieldProps}
          variant="standard"
          type="text"
          className={classes.smallTextField}
          InputProps={{
            disableUnderline: true,
          }}
        />
        % &nbsp;&nbsp;
        <Typography className={classes.pricing_typography}>
          ={" "}
          <CurrencyValue
            value={get(discountedValues, fieldProps.field.name)}
            country={country}
            horizontal_spacing={true}
          />{" "}
          per photo
        </Typography>
      </>
    );
  };
  

  const renderForm = () => {
    return (
      <div>
        <div className={classes.setFolderWrapper}>
          <Typography variant="h5">
            Set Pricing for
            {gallery_type === "photo_art" ? " Photograph " : " Folder/Gallery "}
          </Typography>
        </div>
        <div className={classes.setFolderWrapper}>
          <Typography className={classes.pricing_typography}>
            Pricing Level:
          </Typography>
          <Box display="flex" p={2} width="370px" alignItems="center">
            <Typography className={classes.pricing_typography}>
              Price Per Photo:
            </Typography>
            <Controller
              name={`${field_name_prefix}.base_price`}
              control={control}
              render={renderPriceField}
              className={classes.small_typography}
            />
          </Box>
        </div>
        {gallery_type !== "photo_art" && (
          <>
            <Box p={2}>
              <Typography className={classes.map_typography}>
                Discounts for buying multiple photos:
              </Typography>
              <Box display="flex" p={2} width="370px" alignItems="center">
                <Typography className={classes.small_typography}>
                  Photos 2-5:
                </Typography>
                <Controller
                  name={`${field_name_prefix}.discount1_percentage`}
                  control={control}
                  render={renderDiscountPriceField}
                />
              </Box>
              <Box
                display="flex"
                p={2}
                width="600px"
                alignItems="center"
                justifyContent="space-arround"
              >
                <Typography className={classes.small_typography}>
                  photos 6-10:
                </Typography>

                <Controller
                  name={`${field_name_prefix}.discount2_percentage`}
                  control={control}
                  render={renderDiscountPriceField}
                />
              </Box>
              <Box
                display="flex"
                p={2}
                width="600px"
                alignItems="center"
                justifyContent="space-around"
              >
                <Typography className={classes.small_typography}>
                  Photos 11-50:
                </Typography>
                <Controller
                  name={`${field_name_prefix}.discount3_percentage`}
                  control={control}
                  render={renderDiscountPriceField}
                />
              </Box>
              <Box
                display="flex"
                p={2}
                width="600px"
                alignItems="center"
                justifyContent="space-around"
              >
                <Typography className={classes.small_typography}>
                  Photos 50+:
                </Typography>
                <Controller
                  name={`${field_name_prefix}.discount4_percentage`}
                  control={control}
                  render={renderDiscountPriceField}
                />
              </Box>
            </Box>
          </>
        )}
        <Box>
          <div
            style={{
              display: "flex",
              paddingTop: 30,
              paddingBottom: 30,
              justifyContent: "space-around",
              width: "60%",
            }}
          >
            <Button
              className={classes.normalWhiteBtn}
              onClick={() => setShowForm(false)}
            >
              Close
            </Button>
          </div>
        </Box>
      </div>
    );
  };

  return (
    <>
      {showForm && renderForm()}
      <div>
        <GalleryHighLowResPriceFormFields
          classes={classes}
          control={control}
          field_name_prefix={field_name_prefix}
          optionalLowResPriceChecked={optionalLowResPriceChecked}
          handleOptionalLowResPriceChange={handleOptionalLowResPriceChange}
        />
      {!isEditorForPhotoArt &&
       <GalleryPriceDiscountFormFields
         classes={classes}
         control={control}
         country={country}
         discountedValues={discountedValues}
         field_name_prefix={field_name_prefix}
       />
      }
    </div>
    </>
  );
};
